/* ============================================================
   Microsoft UET Consent Mode - Avada Cookie Bar integration
   ------------------------------------------------------------
   BASELINE / PLACEHOLDER.

   Sets the Microsoft UET consent default to "denied" (the
   privacy-safe state). Per Avada's docs this loads JUST BELOW
   your UET base tag, so window.uetq already exists.

   TO COMPLETE THE INTEGRATION:
   1. In the Avada Cookie Bar app: Integrations (GCM V2, TikTok,
      Pixel) > Microsoft Consent Mode (UET) > Turn on.
   2. Replace the contents of THIS file with Avada's official
      avada-cookiebar-mcm-integration-v1.js (from the app), keeping
      the same filename. Avada's file adds the banner -> consent
      "update" bridge so UET is granted when a visitor accepts.

   Doc: https://docs.avada.io/cookie-help-center/integrations/integrate-with-microsoft-consent-mode-uet
   ============================================================ */
(function () {
  window.uetq = window.uetq || [];
  window.uetq.push('consent', 'default', {
    ad_storage: 'denied'
  });
})();
